module.exports = "<div style=\"width:300px; margin: 10px auto\">\n\t<h2 *ngIf=\"loginService.logged\">Você está logado</h2>\n\t<button *ngIf=\"loginService.logged\" (click)=\"logout()\">Sair</button>\n\t<h2>Login</h2>\n\t<input [disabled]=\"loginService.logged\" type=\"text\" [(ngModel)]=\"username\">\n\t<input [disabled]=\"loginService.logged\" type=\"password\" [(ngModel)]=\"password\">\n\t<button [disabled]=\"loginService.logged\" (click)=\"login()\">Login</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main